import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "moment-timezone";
import forge from "node-forge";
import Address from "./Address";
import CardPayment from "./CardPayment";
import CartList from "./../cart/CartList";
import UnregActionMenu from "../layout/UnregActionMenu";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CartContext from "../../context/cart/CartContext";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import Preloader from "./../layout/Preloader";
import useForm from "../../hooks/useForm";
import "./BillingOrder.css";
import usePageTitle from "../../hooks/usePageTitle";
import { CreditCardConfig } from "./CreditCardConfig";
import { env } from "../../env";

const BillingOrder = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);

  const { getConfigValueByCode } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { token, user } = authContext;
  const cartContext = useContext(CartContext);
  const { cart, loadItems, error } = cartContext;
  const cardContext = useContext(CardContext);
  const { orderLoading, submitOrder } = cardContext;
  const navigationContext = useContext(NavigationContext);
  const { fieldRefs } = navigationContext;
  const [mode, setMode] = useState("Edit");
  const history = useHistory();
  const displayReview = () => {
    console.log("displayReview");
    setMode("Review");
  };
  const displayEdit = (e) => {
    e.preventDefault();
    console.log("displayEdit");
    setMode("Edit");
  };

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Billing",
  });

  useEffect(() => {
    console.log("cart", cart);
    if (!error) {
      loadItems({}, token);
    }
    getCreditCardConfig();
    //eslint-disable-next-line
  }, []);

  const placeOrder = async () => {
    clearAlerts();
    // const cardType = getCardTypeCode(payment.cardNumber);
    const payload = {
      ...payment,
      ...address,
      // zipCode: address.zipcode,
      cardType: "1",
    };
    // delete payload["zipcode"];
    delete payload["phonenumber"];
    const pubKeyE64 = env.REACT_APP_HMW_PUB_KEY;
    if (!pubKeyE64) {
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 464);
      setAlert(msg, "danger");
    }
    const pubKeyBuf = Buffer.from(pubKeyE64, "base64");
    const pubkey = pubKeyBuf.toString();
    console.log("@@@Pubkey", pubkey);
    //encrypt CC with RSA public key
    // var rsaEncrypt = new JSEncrypt();
    // rsaEncrypt.setPublicKey(pubkey);
    // var rsaEncryptedCardNumber = rsaEncrypt.encrypt(payment.cardNumber);
    // payload.cardNumber = rsaEncryptedCardNumber;
    const pubKeyVar = forge.pki.publicKeyFromPem(pubkey);
    // const encBytes = "41111111111111";

    const encrypted = pubKeyVar.encrypt(payment.cardNumber, null, {
      md: forge.md.sha256.create(),
    });
    payload.cardNumber = btoa(encrypted);
    console.log("placeOrder", payload);
    try {
      const res = await submitOrder(payload, token, user);
      console.log("$Res:", res);
      if (res && res.status) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        if (res.status !== "ERROR") {
          history.push("/confirm-order");
        }
      }
    } catch (err) {
      console.log("$ERR:", err.message);
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
    // history.push("/confirm-order");
  };

  const getCardType = (cardNumber) => {
    let card = cardNumber.toString();
    if (card.startsWith("34") || card.startsWith("37")) {
      return "amex";
    } else if (card.startsWith("4")) {
      return "visa";
    } else if (
      card.startsWith("51") ||
      card.startsWith("52") ||
      card.startsWith("53") ||
      card.startsWith("54") ||
      card.startsWith("55") ||
      card.startsWith("22") ||
      card.startsWith("23") ||
      card.startsWith("24") ||
      card.startsWith("25") ||
      card.startsWith("26") ||
      card.startsWith("27")
    ) {
      return "master";
    } else if (card.startsWith("6")) {
      return "discover";
    } else {
      return "invalid";
    }
  };

  // const getCardTypeCode = (cardNumber) => {
  //   let card = getCardType(cardNumber);
  //   if (card === "visa") {
  //     return 1;
  //   } else if (card === "master") {
  //     return 2;
  //   } else if (card === "amex") {
  //     return 3;
  //   } else if (card === "discover") {
  //     return 4;
  //   } else {
  //     return -1;
  //   }
  // };

  const maskCardNumber = (cardNumber) => {
    if (cardNumber !== "" && cardNumber.length > 4) {
      return "#".repeat(cardNumber.length - 4) + cardNumber.substr(-4);
    } else {
      return "";
    }
  };

  const [address, setAddress] = useState({
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    phonenumber: "",
  });
  // let  {address1, address2, city, state, zipcode, phone1, phone2, phone3 } =  address;
  const [addressFieldRefs, setAddressFieldRefs] = useState(null);

  const addressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const phoneNoChange = (value, floatValue) => {
    console.log("Formatted Value", value);
    console.log("UnFormatted Value", floatValue);
    setAddress({ ...address, phonenumber: value });
    setUnformattedAddressValues({
      ...unformattedAddressValues,
      phonenumber: floatValue?.toString(),
    });
  };

  const {
    Popup: PopupAddress,
    validateField: validateAddressField,
    validateAllFields: validateAllAddressFields,
    isFormValid: isAddressFormValid,
    setIsFormValid: setIsAddressFormValid,
    setValidationControl: setAddressValidationControl,
    unformattedValues: unformattedAddressValues,
    setUnformattedValues: setUnformattedAddressValues,
  } = useForm({
    inputList: addressFieldRefs,
    unformattedAddressValues: {
      phoneNumber: "",
    },
    screenName: "order_address",
  });

  useEffect(() => {
    const isValid = validateAllAddressFields();
    setIsAddressFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  const [payment, setPayment] = useState({
    cardholdername: "",
    firstName: "",
    lastName: "",
    cardNumber: "",
    month: "",
    year: "",
    cvvCode: "",
  });

  const [paymentFieldRefs, setPaymentFieldRefs] = useState(null);

  const checkFieldRange = (value, fieldName) => {
    //get allowed ranges for the given field
    console.log("Custom Field", fieldName);
    console.log("Custom value", value);
    console.log("------>card type", getCardType(value));
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx =
      /^5[1-5][0-9]{14}|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]{12}$/;
    var amexpRegEx = /^(?:3([7]|[4])[0-9](\d{12}|\d{14}))$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    let res;
    if (
      visaRegEx.test(value) ||
      mastercardRegEx.test(value) ||
      amexpRegEx.test(value) ||
      discovRegEx.test(value)
    ) {
      res = "";
    } else {
      res = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 415);
    }
    console.log("Custom Field res", res);
    return res;
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    setValidationControl,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: paymentFieldRefs,
    screenName: "order_payment",
    unformattedValuesList: {
      cardNumber: "",
    },
    customRules: {
      cardNumber: checkFieldRange,
    },
    excludePrefix: {
      cardNumber: true,
    },
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payment]);

  // let {cardholdername, cardNumber, month, year, cvvCode } = payment;
  const paymentChange = (e) => {
    setPayment({ ...payment, [e.target.name]: e.target.value });
  };

  const cardNoChange = (value) => {
    console.log(value);
    setPayment({ ...payment, cardNumber: value });
    setUnformattedValues({
      ...unformattedValues,
      cardNumber: value?.toString(),
    });
  };

  const setOriginalValue = (value) => {
    setUnformattedValues({
      ...unformattedValues,
      cardNumber: value,
    });
  };

  const prevCard = () => {
    return payment.cardNumber;
  };

  useEffect(() => {
    console.log("field refs", fieldRefs);
    if (fieldRefs && fieldRefs["payment"]) {
      console.log("Assiging payment refs", fieldRefs["payment"]);
      setPaymentFieldRefs(fieldRefs["payment"]);
      setValidationControl(fieldRefs["payment"]);
    }
    if (fieldRefs && fieldRefs["address"]) {
      console.log(
        "Assiging subscription_address password refs",
        fieldRefs["address"]
      );
      setAddressFieldRefs(fieldRefs["address"]);
      setAddressValidationControl(fieldRefs["address"]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldRefs]);

  useEffect(() => {
    clearAlerts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [cards, setCards] = useState({
    visa: "",
    master: "",
    amex: "",
    discover: "",
  });

  useEffect(() => {
    console.log("credit cards", cards);
  }, [cards]);

  const API_RESOURCES = env.REACT_APP_HMW_API_RESOURCES;
  let getCreditCardConfig = async () => {
    try {
      let resp = await CreditCardConfig();
      console.log("RESP---->", resp);

      const cardDetails = (card) => {
        return resp.filter((ele) => ele.title === card).map((ele) => ele);
      };

      const visa = cardDetails("visa");
      const master = cardDetails("master");
      const amex = cardDetails("amex");
      const discover = cardDetails("discover");
      setCards({ visa, master, amex, discover });
    } catch (err) {
      console.log("Error in getting gallery config");
    }
  };

  return (
    <Fragment>
      {orderLoading && <Preloader />}
      <PopupAddress />
      <Popup />
      <UnregActionMenu role="main" ref={props.mainContentRef} tabIndex="-1" />
      <div className="privateView billing" role="region">
        <div className="billing__processHeader">
          <div
            aria-live="assertive"
            {...(mode === "Edit" && { "aria-current": "step" })}
            className={
              mode === "Edit"
                ? "billing__processHeader__listHeader__active"
                : "billing__processHeader__listHeader"
            }
          >
            <div
              className={
                mode === "Edit"
                  ? "billing__processHeader__pill__active"
                  : "billing__processHeader__pill"
              }
            >
              1
            </div>
            Billing
          </div>
          <div
            aria-live="assertive"
            {...(mode === "Edit" && { "aria-current": "step" })}
            className={
              mode === "Review"
                ? "billing__processHeader__listHeader__active"
                : "billing__processHeader__listHeader"
            }
          >
            <div
              aria-live="assertive"
              className={
                mode === "Review"
                  ? "billing__processHeader__pill__active"
                  : "billing__processHeader__pill"
              }
            >
              2
            </div>
            Place Order
          </div>
        </div>
        <div className="privateView__pageTitle">
          <div> {mode === "Edit" ? "BILLING" : "REVIEW ORDER"} </div>
          {/* <div className="privateView__pageTitle__note">
            <span className="required">*</span>
            denotes a required field
          </div> */}
        </div>
        {mode === "Edit" && (
          <div className="billing__cardList" aria-live="assertive">
            <div className="billing__cardList__cardSection">
              <h2 className="billing__cardList__cardSection__title">
                Enter Credit Card Information
              </h2>
              {/* <CardPayment payment={payment} paymentChange={paymentChange}/> */}
              <CardPayment
                paymentChange={paymentChange}
                cardNoChange={cardNoChange}
                payment={payment}
                getCardType={getCardType}
                onBlur={validateField}
                preserveCardNumber={setOriginalValue}
                prevCard={prevCard}
              />
            </div>
            <div className="billing__cardList__addressSection">
              <h2 className="billing__cardList__addressSection__title">
                Enter Billing Address
              </h2>
              {/* <Address address={address} addressChange={addressChange}/> */}
              <Address
                addressChange={addressChange}
                phoneNoChange={phoneNoChange}
                address={address}
                onBlur={validateAddressField}
              />
            </div>
          </div>
        )}
        {mode === "Review" && (
          <Fragment>
            <div className="billing__cardList" aria-live="assertive">
              <div className="billing__cardList__reviewSection">
                <div className="billing__cardList__reviewSection__title">
                  <h2>BILLING</h2>
                  <div>
                    <a href="#no-link" onClick={displayEdit}>
                      {" "}
                      <i className="fas fa-edit"></i> Edit
                    </a>
                  </div>
                </div>
                <div className="billing__cardList__cardSummary">
                  <div className="billing__cardList__cardSummary__payment">
                    <h3 className="billing__cardList__cardSummary__subTitle">
                      Payment Method
                    </h3>
                    <div className="card-detail">
                      {" "}
                      {maskCardNumber(payment.cardNumber)}
                      {cards.visa !== "" && (
                        <span>
                          {" "}
                          {getCardType(payment.cardNumber) === "visa" && (
                            <img
                              src={API_RESOURCES + cards.visa[0].image}
                              className="payment__formBody__cardIcons__icon"
                              aria-label={cards.visa[0].title + " card"}
                            />
                          )}
                          {getCardType(payment.cardNumber) === "master" && (
                            <img
                              src={API_RESOURCES + cards.master[0].image}
                              className="payment__formBody__cardIcons__icon"
                              aria-label={cards.master[0].title + " card"}
                            />
                          )}
                          {getCardType(payment.cardNumber) === "amex" && (
                            <img
                              src={API_RESOURCES + cards.amex[0].image}
                              className="payment__formBody__cardIcons__icon"
                              aria-label={cards.amex[0].title + " card"}
                            />
                          )}
                          {getCardType(payment.cardNumber) === "discover" && (
                            <img
                              src={API_RESOURCES + cards.discover[0].image}
                              className="payment__formBody__cardIcons__icon"
                              aria-label={cards.discover[0].title + " card"}
                            />
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="billing__cardList__cardSummary__address">
                    <h2 className="billing__cardList__cardSummary__subTitle">
                      Billing Address
                    </h2>
                    <div>{address.address1}</div>
                    <div> {address.address2}</div>
                    <div>
                      {" "}
                      {address.city}, {address.state}, {address.zipcode}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="billing__cartList">
              {cart && <CartList cart={cart} />}
            </div>
          </Fragment>
        )}

        <div className="billing__actions">
          {mode === "Edit" && (
            <input
              aria-label="Proceed to Review "
              type="submit"
              name="btnProceedToCart"
              className="btn btn-primary billing__actions__action"
              onClick={displayReview}
              disabled={!isAddressFormValid || !isFormValid}
              value="Proceed to Review"
              aria-live="assertive"
            />
          )}
          {mode === "Review" && (
            <input
              aria-label="Place Order "
              type="submit"
              name="btnPlaceOrder"
              className="btn btn-primary billing__actions__action"
              onClick={placeOrder}
              value="Place Order"
              aria-live="assertive"
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default BillingOrder;
